import {
  InstallationStatusName,
  useGetAllInstallationStatusesQuery,
  useSaveInstallationMutation
} from 'generated/graphql';
import React from 'react';

export function useSaveInstallation(isInstalled: boolean) {
  const [
    fnMutate,
    tuple
  ] = useSaveInstallationMutation({
    refetchQueries: []
  });

  const { data } = useQuery(isInstalled);

  const fnWrappedMutate = React.useCallback(
    async (id: string) => {
      await fnMutate({
        variables: {
          input: {
            id,
            statusId: data.id
          }
        }
      });
    },
    [
      data.id,
      fnMutate
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}


export interface IData {
  id: string;
  name: string;
  displayName: string;
}

export function useQuery(isInstalled: boolean) {
  const tuple = useGetAllInstallationStatusesQuery({
    variables: {
    }
  });

  return React.useMemo(
    () => {
      let nodeName: InstallationStatusName = 'complete';
      if (isInstalled) {
        nodeName = 'toDo';
      }
      const node = tuple.data?.installationStatuses?.find((rec) => rec.name === nodeName);
      const data: IData = {
        id: node?.id ?? '',
        name: node?.name ?? '',
        displayName: node?.displayName ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [
      isInstalled,
      tuple
    ]
  );
}
